export const pageConfig = {
  "title": "Funnel",
  "titleCN": "Funnel",
  "path": "/funnel/registerFunnelDaily",
  "defaultTab": "registerFunnelDaily",
  "tabList": [
    {
      "id": "registerFunnelDaily",
      "tabName": "",
      "tabNameCN": "",
      "isHaveNotification": true,
      "refresh": false,
      "notificationPath": "/funnel/registerFunnelDaily",
      "path": "/funnel/registerFunnelDaily",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205901",
        "pageName": "funnelRegisterFunnelDaily",
        "extInfo": "funnelRegisterFunnelDaily",
        "pagePath": "/funnel/registerFunnelDaily"
      },
      "filters": [
        {
          "name": "RegisterFunnelDailyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": false,
          "filterPath": "/funnel/registerFunnelDaily",
          "componentList": [
            {
              "name": "FunnelStepCardService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/funnel/register/pc/device_conversion",
                }
              },

              children: [
                {
                  "name": "MetricsCardTitle",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "titleEn": "User Conversion%",
                      "titleCn": "用户转化率%",
                      "isMetricsExplain": false
                    }
                  }
                },
                {
                  "name": "FunnelStepCardContext",
                  "style": {},
                  "children": [
                    {
                      "name": "FunnelStepCard",
                      "className": "",
                      "type": "view",
                      "style": { height: '130px' },
                      "props": {
                        "config": {
                          "formatRule": 'percent2Decimal',
                          "dodData":
                          {
                            lost: {
                              titleEn: 'LOST',
                              titleCn: '折损',
                              formatRule: 'absPercent1Decimal',
                              extendFormatRule: 'thousandsInit',
                            }
                          },
                        }
                      },
                    },
                  ]
                },
              ]
            },
            {
              "name": "FunnelCardService",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                api: "/api/v1/dashboard/pc/funnel/register/pc/funnle",
                formatterColumns: [
                  {
                    key: "device_count",
                    formatRule: "thousandsInit",
                  },
                  {
                    key: "conversion_rate",
                    formatRule: "percent1Decimal",
                  },
                  {
                    key: "lost_rate",
                    formatRule: "percent1Decimal",
                  }
                ],
              },
              "children": [
                {
                  "name": "FunnelCardContent",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    titleEn: "Funnel",
                    titleCn: "漏斗",
                    tipsEn: "",
                    tipsCn: "",
                    bubbleTitleEn: "{{textMsg}}",
                    bubbleTitleCn: "{{textMsg}}",
                    tabOption: [
                      {
                        value: "total",
                        nameEn: "Total",
                        nameCn: "总体",
                      },
                      {
                        value: "android",
                        nameEn: "Android",
                        nameCn: "Android",
                      },
                      {
                        value: "ios",
                        nameEn: "IOS",
                        nameCn: "IOS",
                      }
                    ],
                    columns: [
                      {
                        key: "textMsg",
                        nameEn: "Step",
                        nameCn: "步骤",
                        className: "td-first",
                      },
                      {
                        key: "device_count_msg",
                        nameEn: "User Count & conversion%",
                        nameCn: "用户数&转化率%",
                        className: "td-center",
                        showBg: true,
                        bgDataKey: 'conversion_rate',
                      },
                      {
                        key: "lost_rate",
                        nameEn: "Lost%",
                        nameCn: "折损%",
                        className: "td-end",
                      },
                    ],
                    downloadColumns: [
                      {
                        key: "textMsg",
                        nameEn: "Step",
                        nameCn: "步骤",
                        className: "td-first",
                      },
                      {
                        key: "device_count_msg",
                        nameEn: "User Count & conversion%",
                        nameCn: "用户数&转化率%",
                        className: "td-center",
                        showBg: true,
                        bgDataKey: 'conversion_rate',
                      },
                      {
                        key: "lost_rate",
                        nameEn: "Lost%",
                        nameCn: "折损%",
                        className: "td-end",
                      },
                    ],
                    bubbleColumns: [
                      {
                        key: "device_count_msg",
                        nameEn: "User Count & conversion%",
                        nameCn: "用户数&转化率%",
                      }
                    ],
                    showConfig: {
                      showTitle: true,
                      showDesc: false,
                      showTips: false,
                      showTab: false,
                      showDownload: true,
                    },

                  },
                },
              ]
            },
            {
              "name": "FunnelTableService",
              "type": "view",
              "props": {
                style: { marginTop: 20 },
                disabledDimList: ['game_stage'],
              },
              children: [{
                "name": "FunnelTable",
                "className": "",
                "type": "view",
                "style": {},
                "props": {
                  defaultValueType: 'value_only',
                  isShowValueType: false,
                  showModalData: false,
                  copyTitleList: ['current'],
                  haveDate: false,
                  isEN: true,
                  api: {
                    tableApi: '/api/v1/dashboard/pc/funnel/register/pc/overall_performance',
                    tableDownloadApi: '/api/v1/dashboard/pc/funnel/register/pc/overall_performance/download'
                  }
                },
              }]
            },
          ]
        }
      ]
    },
  ]
};
